// others
import { Button, message, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams ,useNavigate} from "react-router-dom";
import { useGetOrganization } from "../../../../api/v1";
import { AppDispatch } from "../../../../redux/store";
import { getPresignedImage } from "../../../../utils/media";
import { Popup, PopupConfirm } from "../../../atoms/Popup";
import SendForSignature from "../../../molecules/PDFViewer/DocuSign/SendForSignature";
import { sendTenantInvite } from "../../BookingListing/ducks/actions";
import { usePendingRequestsActions } from "../../PendingApprovalRequets/api/useRefreshPendingRequests";
import { generateSettlementReport } from "../../TerminationProcess/ducks/services";
import { checkUpfrontPayment, getBookingDetail, updateBooking, updateBookingStatus } from "../ducks/actions";
import { CreateEjariContract, sendContractForSignService, updatePdcService } from "../ducks/services";
import { useTorRules } from "../hooks/useTorRules";
import { useLeaseTermAmendments } from "./LeaseActions/api/v1/useLeaseTermAmendments";
import AddContractNumber from "./modalContent/AddContractNumber";
import MoveOutPopup from "./modalContent/MoveOutPopup";
import RejectPopup from "./modalContent/rejectPopup";
import { getDiffInDays, reasonsData, validateChecks, viewRenewalLease } from "./utils";
import { isCommercialUsageType } from "../../../libs/utils";

interface IProps {
  handleEditPressEvent(arg0: string, arg1: Boolean): void;
  renewal: boolean;
  setLoading?: (val?: boolean) => void;
  setRenewalFormConfirm?: any;
  setSendSettlementReport?: any;
  moveOutScreen?: boolean;
}

interface actionType {
  label?: string;
  type?: "delete" | "accept" | "reject";
  action?: () => void;
  visible?: boolean;
  disabled?: boolean;
}

const loginUserId = JSON.parse(window.localStorage.getItem("login-response"))?.userId;
const loginUserRole = JSON.parse(window.localStorage.getItem("login-response"))?.usertype;

const ActionButtons = (props: IProps) => {
  const { Title } = Typography;
  const { organization } = useGetOrganization();
  const { refreshPendingRequests } = usePendingRequestsActions();
  const { submit, loading: _loading } = useLeaseTermAmendments("booking/leaseAmendmentUpdateRequest");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const userScreenAccess: any = useSelector((state: any) => state?.userScreens?.userScreenAccess);
  const sentDocs = bookingDetails?.docuSign || [];
  const { state } = useLocation();
  let isRenewal =
    (state?.renewal && state?.renewal) ||
    bookingDetails?.leaseType === "renewal" ||
    bookingDetails?.leaseType === "extension";
  const isBooking = bookingDetails && Object.keys(bookingDetails).length > 0;
  const [LOGIN_USER, setLoginUser] = useState(bookingDetails?.loginUserType || "");
  //ADDED FOR BUG: 8137

  const { isTurnoverRentOnly } = useTorRules();

  const getUserForLease = () => {
    if (
      bookingDetails?.leaseManager &&
      loginUserId === bookingDetails?.leaseManager?.userId &&
      LOGIN_USER === "managersManager"
    )
      return "landlord"; //grants landlord permission in this case
  };

  const { leaseId = bookingDetails.leaseId } = useParams();
  const isCommercialRenewal = isCommercialUsageType(bookingDetails?.propertyDetails?.usagesType);
  const navigateToCommercialRenewalFlow = () => {
    if (leaseId) navigate(`/renewals/${leaseId}`);
  };
  const [modalvisible, setModalvisible] = useState(false);
  const [createEjariNumber, setEjariNumber] = useState(false);
  const [modalTrigger, setModalTrigger] = useState(0);
  const [LEASE_USER, setLeaseUser] = useState(getUserForLease());
  const loginUserType = (users = []) => !!users?.includes(LEASE_USER || LOGIN_USER); //ADDED FOR BUG: 8137
  let moveOutScreenStatus = state?.moveOut || bookingDetails?.moveOutStatus;

  useEffect(() => {
    //ADDED TO SOLVE BUG FOR LOGINUSERTYPE NOT COMING IN RESP OF UPDATEAPIS
    bookingDetails?.loginUserType && setLoginUser(bookingDetails?.loginUserType);
  }, [bookingDetails?.loginUserType]);

  useEffect(() => {
    bookingDetails?.leaseManager && setLeaseUser(getUserForLease());
  }, [bookingDetails?.leaseManager]);

  const onStatusBookingForm = async (body, _showAlert = true) => {
    props?.setLoading && props?.setLoading(true);
    try {
      await dispatch(updateBookingStatus({ leaseId, body }));

      setTimeout(async () => {
        await dispatch(getBookingDetail(bookingDetails.leaseId)); //FIXED ONCE FOR ALL
      }, 400);
      props?.setLoading && props?.setLoading(false);
    } catch (_error) {
      props?.setLoading && props?.setLoading(false);
    }
  };

  const onCancelBook = async (data?: any) => {
    let body = { comments: data?.comments, status: "booking_reject" };
    await onStatusBookingForm(body);
    setModalvisible(false);
  };

  //Api call for email send and status update
  const sendToTenant = async () => {
    try {
      const email =
        bookingDetails?.isSignatory === "no"
          ? bookingDetails?.signatoryUser?.email
          : bookingDetails?.tenantDetails?.email;

      if (email && leaseId) {
        props?.setLoading && props?.setLoading(true);
        let payload = [
          {
            email: email,
            usertype: "tenant",
            leaseId: leaseId,
            inviteAll: false,
          },
        ];
        let successMessage = "Invite sent to tenant successfully";
        const status = await sendTenantInvite(payload);

        if (status === 200) {
          message.success(successMessage);
          let body = {
            status: "tenant_invitation_sent",
          };
          await onStatusBookingForm(body);
        }
        props?.setLoading && props?.setLoading(false);
      } else {
        message.error("No email id present");
      }
    } catch (_error) {
      props?.setLoading && props?.setLoading(false);
    }
  };

  const checkRequiredFields = () => {
    const leaseTerms = bookingDetails?.leaseTerms;
    const tenant = bookingDetails?.tenantDetails;

    let requiredFields = [];
    if (!leaseTerms?.leaseStartDate || !leaseTerms?.leaseEndDate || !leaseTerms?.leaseNature)
      requiredFields.push("Lease Terms");

    if (bookingDetails?.propertyDetails?.usagesType !== "Commercial") {
      if (!tenant?.tenantNameAR || !tenant?.maritalStatus) requiredFields.push("Tenant Details");
    }
    return requiredFields;
  };

  const hasAllFieldValues = (fields?: Record<string, unknown>) => {
    if (!fields || Object.keys(fields).length === 0) return false;

    return Object.values(fields).every((field) => {
      if (!field || typeof field !== "object" || !("value" in field)) return false;

      const value = (field as Record<string, unknown>).value;
      return value !== undefined && value !== null && value !== "";
    });
  };

  const ApproveTenantInfo = async () => {
    const body = {
      status: "tenant_information_approved",
    };

    if (Boolean(organization?.enableCustomFields) && !hasAllFieldValues(bookingDetails?.customFields)) {
      message.info("Please complete all custom fields before proceeding");
      return;
    }

    const financialDimensions = bookingDetails?.propertyDetails?.financialDimensions;
    if (Boolean(organization?.enableFinancialDimensions) && !hasAllFieldValues(financialDimensions)) {
      message.info("Please complete all financial dimensions before proceeding");
      return;
    }

    const fields: Array<any> = checkRequiredFields();
    if (fields?.length > 0) {
      message.info(`Please kindly complete ${fields?.join(", ")}`);
      return;
    }
    //Task 8297
    if (!bookingDetails?.tenantDetails?.paymentPlanId) {
      //|| !bookingDetails?.leaseTerms?.contractAmount
      message.info("Contract amount is not present. Please kindly select the payment plan before proceeding");
      return;
    }
    //Task 8442
    if (bookingDetails?.leaseTerms?.moveInDateConfirm !== "yes") {
      message.info("Move-In Date is not confirmed. Please check the lease terms section");
      return;
    }
    PopupConfirm({
      title: "Are you sure you want to approve tenant information?",
      onOk: async () => {
        await onStatusBookingForm(body);
        await refreshPendingRequests();
      },
      okText: "Yes",
    });
  };

  const RejectTenantInfo = async (data: any) => {
    const body = {
      status: "kyc_rejected",
      rejectionReason: data?.comments ?? "",
    };
    const fields: Array<any> = checkRequiredFields();
    if (fields?.length > 0) {
      message.info(`Please kindly complete ${fields?.join(", ")}`);
      return;
    }
    await onStatusBookingForm(body);
    await refreshPendingRequests();
    setModalvisible(false);
  };

  // confirm Decline for story 8455

  const confirmDecline = async (data: any) => {
    PopupConfirm({
      title:
        "This will set the tenant's renewal decision to Renewal Declined and set the Lease status to Active - Vacating. Are you sure you wish to proceed?",
      onOk: async () => {
        try {
          props?.setLoading(true);
          const response = await dispatch(
            updateBooking({
              leaseId,
              body: {
                onlyBooking: true,
                renewalToTenant: "renewal_declined",
                reason: data?.reason,
                comments: data?.comments,
              },
            }),
          );

          if (response?.data?.code === 200) {
            message.success(response?.data?.message);
            await dispatch(getBookingDetail(bookingDetails?.leaseId));
            props?.setLoading(false);
            setModalvisible(false);
          }
        } catch (error) {
          if (error?.response?.data?.success === false) {
            message.error(error?.response?.data?.error);
          }
        }
      },
      okText: "Yes",
    });
  };

  const sendForEsignature = async (document) => {
    PopupConfirm({
      title: "This action will send the document to the tenant for signature. Are you sure?",
      cancelText: "No",
      okText: "Yes",
      onOk: async () => {
        props?.setLoading(true);
        // const res = await dispatch(sendContractForSign({ leaseId, document }));
        await sendContractForSignService({ leaseId, document });
        await dispatch(getBookingDetail(bookingDetails?.leaseId));
        props?.setLoading(false);
      },
    });
  };

  const sendForApproval = async () => {
    const body = {
      sendForApproval: "yes",
    };
    PopupConfirm({
      title: "This action will send the booking for approval. Are you sure?",
      onOk: async () => {
        onStatusBookingForm(body);
        await dispatch(getBookingDetail(bookingDetails.leaseId));
        await refreshPendingRequests();
      },
      okText: "Yes",
    });
  };

  const editBooking = async (approvalType?: string) => {
    let body = {};
    if (approvalType === "bookingApproval") body = { editBooking: "yes" };
    else if (approvalType === "leaseApproval") body = { editLeaseApproval: "yes" };

    if (body) {
      onStatusBookingForm(body);
      await dispatch(getBookingDetail(bookingDetails.leaseId));
    }
  };

  const AcceptApproval = async () => {
    const body = { sendForApproval: "approved" };
    PopupConfirm({
      title: "Are you sure you want to approve the booking?",
      onOk: async () => {
        await onStatusBookingForm(body);
        await dispatch(getBookingDetail(bookingDetails.leaseId));
        await refreshPendingRequests();
      },
      okText: "Yes",
    });
  };

  const RejectApproval = async (data) => {
    const body = {
      sendForApproval: "rejected",
      rejectionReason: data?.comments ?? "",
    };
    await onStatusBookingForm(body);
    await dispatch(getBookingDetail(bookingDetails.leaseId));
    await refreshPendingRequests();
    setModalvisible(false);
  };

  const confirmPayments = async () => {
    if (!bookingDetails?.ejari?.contractNumber && isRenewal) {
      setEjariNumber(true);
      openModalPopup(4);
      return false;
    } else {
      if (isTurnoverRentOnly || bookingDetails?.paymentSchedule?.length > 0) {
        let payload = {
          paymentSchedule: bookingDetails?.paymentSchedule,
          leaseId: leaseId,
        };
        if (validateChecks(bookingDetails?.paymentSchedule) === true) return; //TASK: 8273
        PopupConfirm({
          title: "Are you sure you want to confirm the payment schedule?",
          onOk: async () => {
            props?.setLoading && props?.setLoading(true);
            await updatePdcService(payload);
            props?.setLoading && props?.setLoading(false);
            await dispatch(getBookingDetail(bookingDetails?.leaseId));
            await refreshPendingRequests();
            message.success("Payment schedule has been confirmed");
          },
          okText: "Yes",
        });
      } else {
        message.error("Payment details not filled");
      }
    }
  };

  const sendLeaseForApproval = async () => {
    const body = { sendLeaseForApproval: "yes" };
    PopupConfirm({
      title: "This action will send the lease for approval. Are you sure?",
      onOk: async () => {
        onStatusBookingForm(body);
        await dispatch(getBookingDetail(bookingDetails.leaseId));
        await refreshPendingRequests();
      },
      okText: "Yes",
    });
  };

  const AcceptLeaseApproval = async () => {
    const body = { sendLeaseForApproval: "approved" };
    PopupConfirm({
      title: "Are you sure you want to approve the lease?",
      onOk: async () => {
        onStatusBookingForm(body);
        await dispatch(getBookingDetail(bookingDetails.leaseId));
        await refreshPendingRequests();
      },
      okText: "Yes",
    });
  };

  const RejectLeaseApproval = async (data) => {
    const body = {
      sendLeaseForApproval: "rejected",
      rejectionReason: data?.comments ?? "",
    };
    await onStatusBookingForm(body);
    await dispatch(getBookingDetail(bookingDetails.leaseId));
    await refreshPendingRequests();
    setModalvisible(false);
  };

  const activateEjari = async () => {
    const body = { status: "leaseActive" };
    const response = await dispatch(checkUpfrontPayment(bookingDetails.leaseId));
    if (response?.result?.paid) {
      PopupConfirm({
        title: "Confirm Lease Activation",
        content: `Activating the lease will grant the tenant access to their lease details, 
        payment options and service requests on their app/portal. 
        Ensure that handover and snagging are fully completed before proceeding.`,
        onOk: async () => {
          onStatusBookingForm(body);
          await dispatch(getBookingDetail(bookingDetails.leaseId));
          await refreshPendingRequests();
        },
        okText: "Proceed",
        showIcon: false,
      });
    } else {
      PopupConfirm({
        title: "Caution: First rent installment is unpaid. Proceed anyway?",
        onOk: async () => {
          onStatusBookingForm(body);
          await dispatch(getBookingDetail(bookingDetails.leaseId));
        },
        okText: "Yes",
        showIcon: false,
      });
    }
  };

  const createEjari = async () => {
    if (props?.renewal && !bookingDetails?.ejari?.contractNumber) {
      openModalPopup(4);
      return;
    }
    PopupConfirm({
      title: "Are you sure you want to Create Ejari?",
      onOk: async () => {
        props?.setLoading(true);
        try {
          const res = await CreateEjariContract(leaseId);
          message.success(res?.data?.message);
          props?.setLoading(false);
          await dispatch(getBookingDetail(bookingDetails.leaseId));
        } catch ({ response }) {
          message.error(response?.data?.error);
          props?.setLoading(false);
        }
      },
      okText: "Yes",
    });
  };

  const updateContractNumber = async (data) => {
    let body = { ...bookingDetails?.ejari, ...data };
    await onStatusBookingForm(body);
    await dispatch(getBookingDetail(bookingDetails?.leaseId));
  };

  //  if is return low value than renewalNoticeDays and press cancell button

  const onCancelButton = (type) => {
    let body: any = {};
    if (
      getDiffInDays(bookingDetails?.parentLeaseTerms?.leaseEndDate) < bookingDetails?.renewalNoticeDays &&
      type === "approval"
    ) {
      body["renewalSendForApproval"] = "approved";
      onStatusBookingForm(body, false);
    }
  };

  const handleRenewal = async (type: string, bool?: boolean) => {
    let body: any = {};
    let title: string = "";
    switch (type) {
      case "create":
        body["renewalSendForApproval"] = "yes";
        title = "Are you sure?";
        break;
      case "edit_renewal":
        body["renewalSendForApproval"] = "editRenewal";
        title = "Are you sure you want to edit renewal terms?";
        break;
      case "approval":
        body["renewalSendForApproval"] = "approved";
        title = "Are you sure you want to approve renewal terms?";
        break;
      case "send_renewal":
        body["renewalSendForApproval"] = "approved";
        body["renewalStatus"] = "sent";
        if (bool) {
          if (getDiffInDays(bookingDetails?.parentLeaseTerms?.leaseEndDate) < bookingDetails?.renewalNoticeDays) {
            body.renewalStatus = "sent";
            title =
              "The renewal notice window has already passed, would you like to send the renewal notice (if available) now?";
          } else {
            title = "This action will approve the renewal request. Are you sure?";
          }
        } else {
          if (getDiffInDays(bookingDetails?.parentLeaseTerms?.leaseEndDate) < bookingDetails?.renewalNoticeDays) {
            body.renewalStatus = "sent";
            title =
              "The renewal notice window has already passed, would you like to send the renewal notice (if available) now?";
          }
        }

        break;
      // for payment plan approval
      case "payment_plan_approve":
        body["paymentPlanSendForApproval"] = "approved";
        if (bool) title = "Are you sure you want to approve payment plans?";
        break;
    }

    if (title) {
      PopupConfirm({
        title: title,
        onOk: async () => {
          await onStatusBookingForm(body);
          await refreshPendingRequests();
          if (type === "edit_renewal" && isCommercialRenewal) {
            navigateToCommercialRenewalFlow();
          }
        },
        okText: "Yes",

        onCancel() {
          onCancelButton(type);
        },
      });
    } else {
      onStatusBookingForm(body);
    }
  };

  const openModalPopup = (index) => {
    setModalTrigger(index);
    setModalvisible(true);
  };

  const onRejectPaymentApproval = async (data: any) => {
    await onStatusBookingForm({
      comments: data?.comments,
      paymentPlanSendForApproval: "rejected",
    });
    await refreshPendingRequests();
    setModalvisible(false);
  };

  const onRejectApproval = async (data: any) => {
    await onStatusBookingForm({
      comments: data?.comments,
      renewalSendForApproval: "rejected",
    });
    await refreshPendingRequests();
    setModalvisible(false);
  };

  //  ******* for stroy 8455 Upcoming Renewals > Add buttons for Confirm Renewal and Confirm Move-out ****
  const confirmRenwal = (renewalStatus: string) => {
    const inputDate = new Date(bookingDetails?.leaseTerms?.leaseStartDate);
    const currentDate = new Date(Date.now());
    const isExpired = currentDate > inputDate;

    if (props?.moveOutScreen) return false;
    if (
      bookingDetails.parentleaseId &&
      leaseId !== bookingDetails.parentleaseId &&
      !getDepositStatus &&
      isRenewal &&
      leaseStatus !== "lease_expired"
    ) {
      // according to Aajay for 8455 if lease Start Date  less than current date then lease is expired

      if (
        (leaseStatus === "renewal_sent" && renewalStatus === "sent") ||
        renewalStatus === "renewal_declined" ||
        renewalStatus === "sent" ||
        renewalStatus === "ready_to_send" ||
        renewalStatus === "moveout_confirmed"
      )
        return true;
      else if (leaseStatus === "renewal_sent" && renewalStatus === "sent" && isExpired) return true;
    } else {
      return false;
    }
  };

  //  ******* for stroy 8455 Upcoming Renewals > Add buttons for Confirm Renewal and Confirm Move-out ****
  const declinRenwal = (renewalStatus: string) => {
    if (
      bookingDetails?.parentleaseId &&
      leaseId !== bookingDetails?.parentleaseId &&
      !getDepositStatus &&
      !bookingCancelled &&
      isRenewal &&
      leaseStatus !== "lease_expired" &&
      !contractCreated
    ) {
      if (
        (leaseStatus === "renewal_sent" && renewalStatus === "sent") ||
        (leaseStatus !== "active" && renewalStatus === "renewal_accepted") ||
        ((renewalStatus === "sent" || renewalStatus === "ready_to_send") && leaseStatus !== "contract_signed")
      )
        return true;
    } else {
      return false;
    }
  };

  //  ******* for stroy 8455 Upcoming Renewals > Add buttons for Confirm Renewal and Confirm Move-out ****
  const confirmMoveOut = (renewalStatus: string) => {
    if (props?.moveOutScreen) return false;
    if (
      bookingDetails.parentleaseId &&
      leaseId !== bookingDetails.parentleaseId &&
      !getDepositStatus &&
      !bookingCancelled &&
      isRenewal &&
      leaseStatus !== "lease_expired"
    ) {
      if (renewalStatus === "renewal_declined") return true;
    } else {
      return false;
    }
  };

  const showModalForConfirmRenwal = () => {
    // handleRenewal
    props.handleEditPressEvent("4", true);
  };

  // for Approve booking exetension request story-9783 and sprint 39
  const approveBookingExtention = () => {
    PopupConfirm({
      title: `This will change the expiry date of this booking from ${bookingDetails?.bookingExpiryDate.slice(
        0,
        10,
      )} to ${bookingDetails?.bookingExtension?.submittedDate?.slice(0, 10)}. Are you sure?`,
      onOk: async () => {
        try {
          const body = {
            bookingExtensionApproval: "approved",
          };
          await onStatusBookingForm(body);
          await refreshPendingRequests();
          setModalvisible(false);
        } catch ({ response }) {
          message.error(response?.data?.error);
        }
      },
      okText: "Yes",
    });
  };

  // for Approve booking exetension request story-9783 and sprint 39
  const rejectBookingExtention = async (data) => {
    try {
      const body = {
        bookingExtensionApproval: "rejected",
        reason: data?.comments ?? "",
      };
      await onStatusBookingForm(body);
      await refreshPendingRequests();
      setModalvisible(false);
    } catch (_error) {
      message.error("Something went wrong while rejecting the booking extension");
    }
  };

  // on move-out confirm Final Settlement
  //  button click generate Settlement report

  const confirmFinalSettlement = async () => {
    if (bookingDetails?.settlementApproval === "pending") {
      message.error("Move-out Summary requires approval before it can be confirmed.");
      return false;
    } else {
      try {
        props?.setLoading && props?.setLoading(true);
        let response = await generateSettlementReport(leaseId);

        if (response?.code === 200) {
          props?.setLoading && props?.setLoading(false);
          message.success("move-out settlement report generated successfully.");
          dispatch(getBookingDetail(bookingDetails.leaseId + "?moveout=yes"));
        }
      } catch (error) {
        props?.setLoading && props?.setLoading(false);
      }
    }
  };

  // on move-out after confirm Final Settlement
  //  sent to tenant generated Settlement report

  const sendSettlementReport = async () => {
    const getSettlmentReport = bookingDetails?.documents?.find((item) => item?.documentName === "settlmentReport");

    try {
      const url = await getPresignedImage([getSettlmentReport?.documentId]);
      if (url && url.length > 0) {
        let payLoad = {
          url: url[0],
          docType: "settlmentReport",
        };
        props?.setSendSettlementReport(payLoad);
      }
    } catch (_error) {
      message.error("Something went wrong while sending the settlement report");
    }
  };

  const allowLateRenewal = () => {
    PopupConfirm({
      title:
        "This action will enable the tenant to see his lease and make a renewal decision from his mobile app. Are you sure?",
      onOk: async () => {
        try {
          const body = {
            allowLateRenewal: "yes",
          };
          await onStatusBookingForm(body, true);
          setModalvisible(false);
        } catch ({ response }) {
          message.error(response?.data?.error);
        }
      },
      okText: "Yes",
    });
  };

  const renewalNoticeSend = () => {
    PopupConfirm({
      title: "This will send a renewal notice to the tenant with the current rental terms. Do you wish to continue?",
      onOk: async () => {
        try {
          const body = {
            renewalToTenant: "sent",
          };
          await onStatusBookingForm(body, true);
        } catch ({ response }) {
          message.error(response?.data?.error);
        }
      },
      okText: "Yes",
    });
  };

  const leaseAmendmentRequestApproval = (type) => {
    PopupConfirm({
      title: `Are you sure, you want ${type}`,
      onOk: async () => {
        const payload = {
          leaseId,
          leaseAmendmentRequest: type,
        };
        const response = await submit(payload);
        if (response?.code === 200) {
          await refreshPendingRequests();
          leaseId && dispatch(getBookingDetail(leaseId));
          message.success(`Lease amendments ${type} successfully`);
        }
      },
      okText: "Yes",
    });
  };
  const popups = [
    {
      content: <RejectPopup handleReject={(data) => RejectTenantInfo(data)} onClose={() => setModalvisible(false)} />,
    },
    {
      content: <RejectPopup handleReject={RejectApproval} onClose={() => setModalvisible(false)} />,
    },
    {
      content: <RejectPopup handleReject={RejectLeaseApproval} onClose={() => setModalvisible(false)} />,
    },
    {
      content: <RejectPopup handleReject={onRejectApproval} onClose={() => setModalvisible(false)} />,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          Add Ejari Contract Number
        </Title>
      ),
      content: (
        <AddContractNumber
          onClose={() => setModalvisible(false)}
          createEjariNumber={createEjariNumber}
          handleUpdate={updateContractNumber}
        />
      ),
    },
    {
      content: <RejectPopup handleReject={onRejectPaymentApproval} onClose={() => setModalvisible(false)} />,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          Cancel Booking
        </Title>
      ),
      content: <RejectPopup handleReject={onCancelBook} type={"cancel"} onClose={() => setModalvisible(false)} />,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          Decline Renewal
        </Title>
      ),
      content: (
        <RejectPopup
          handleReject={(data) => confirmDecline(data)}
          onClose={() => setModalvisible(false)}
          reasonsData={reasonsData}
          label={"Select a vacating reason"}
          type={"decline_renewal"}
        />
      ),
    },
    {
      title: (
        <Title level={3} className="mb-0">
          Confirm Move-out
        </Title>
      ),
      content: (
        <MoveOutPopup
          onClose={() => setModalvisible(false)}
          propertyId={bookingDetails?.propertyId}
          leaseExpireDate={bookingDetails?.parentLeaseTerms?.leaseEndDate}
          propertyDetail={bookingDetails?.propertyDetails}
          unitId={bookingDetails?.unitId}
        />
      ),
    },
    {
      content: (
        <RejectPopup handleReject={(data) => rejectBookingExtention(data)} onClose={() => setModalvisible(false)} />
      ),
    },
    {
      title: (
        <Title level={3} className="mb-0">
          {sentDocs?.length > 0 ? "Resend for Signature" : "Send for Signature"}
        </Title>
      ),
      content: <SendForSignature setSendForSignature={setModalvisible} documentName={""} />,
      width: 700,
      style: { padding: "22px 4px 24px" },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: modalvisible,
    title: popups[modalTrigger]?.title || (
      <Title level={3} className="mb-0">
        Reject Reason
      </Title>
    ),
    content: popups[modalTrigger]?.content,
    style: popups[modalTrigger]?.style,
    width: popups[modalTrigger]?.width || 650,
    onCancel: () => setModalvisible(false),
  };

  const leaseStatus = bookingDetails?.leaseStatus;
  const renewalStatus = bookingDetails?.renewalStatus;

  const renewalApproval = bookingDetails?.renewalApproval === "enable" ? true : false;
  const managerApproval = bookingDetails?.managerApproval === "enable" ? true : false;
  const leaseManagerApproval = bookingDetails?.leaseManagerApproval === "enable" ? true : false;

  const documentsPending = bookingDetails?.requiredDocuments?.filter((item) => item.status !== "approved")?.length;
  const kycApproved = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "kyc_approved");
  const bookingApproved = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "booking_approved");
  const depositPaid = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "deposit_paid");
  const paymentsReceived = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "rent_payments_received");
  const contractCreated = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "contract_created");
  const contractSent = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "awaiting_tenant_signature");
  const tenantSigned = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "awaiting_landlord_signature");
  const contractSigned = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "contract_signed");
  const bookingCancelled = !!bookingDetails?.leaseStatusHistory?.find((e) => e.status === "booking_cancelled");
  const isLandLoardSigned = bookingDetails?.leaseStatus === "awaiting_landlord_signature";
  // for extend date of booking

  let bookingExtension = !!bookingDetails?.bookingExtension?.submittedDate;

  const statusMappingArray = [
    { key: "booking_created", value: leaseStatus === "booking_created" },
    {
      key: "tenant_invitation_sent",
      value: leaseStatus === "tenant_invitation_sent",
    },
    {
      key: "tenant_submitted",
      value: leaseStatus === "kyc_submitted" || leaseStatus === "documents_submitted",
    },
    {
      key: "documents_approved",
      value:
        leaseStatus === "documents_approved" ||
        (bookingDetails?.requiredDocuments?.length > 0 && documentsPending === 0),
    },
    {
      key: "kyc_approved",
      value: leaseStatus === "kyc_approved" || kycApproved,
    },
    { key: "kyc_rejected", value: leaseStatus === "kyc_rejected" },
    {
      key: "send_for_booking_approval",
      value:
        kycApproved && managerApproval && !bookingApproved && leaseStatus !== "booking_form_sent" && !paymentsReceived,
    }, //last2 part added to hide on the status
    {
      key: "sent_for_booking_approval",
      value: leaseStatus === "sent_for_booking_approval",
    },
    { key: "confirm_pdc", value: leaseStatus === "sent_for_booking_approval" },
    {
      key: "send_for_lease_approval",
      value: paymentsReceived && leaseManagerApproval && !contractCreated,
    },
    {
      key: "sent_for_lease_approval",
      value: leaseStatus === "sent_for_lease_approval",
    },
    {
      key: "booking_cancelled",
      value: bookingCancelled || leaseStatus === "booking_rejected",
    },
    { key: "active", value: leaseStatus === "active" },
  ];

  const statusMap = statusMappingArray.reduce((acc, { key, value }) => {
    acc[key] = value;
    return acc;
  }, {});

  // show cancel booking button until booking not deposit for this purpose
  // first I am checking leaseHistory if deposit exist in leaseHistory then
  //  dnot show cancel booking button

  const getDepositStatus = bookingDetails?.leaseStatusHistory?.find((item) => item?.status === "deposit_paid");
  // leaseAmendmentRequest
  const actionButtons: Array<actionType> = [
    {
      label: "Cancel Booking",
      type: "delete",
      action: () => openModalPopup(6),
      visible:
        isBooking &&
        !isRenewal &&
        !state?.moveOut &&
        !statusMap["active"] &&
        !bookingCancelled &&
        !getDepositStatus?.status &&
        !bookingCancelled &&
        leaseStatus !== "active_vacating" &&
        leaseStatus !== "active_renewing" &&
        leaseStatus !== "lease_expired",
    },
    {
      label: "Approve Lease Amendments",
      type: "accept",
      action: () => leaseAmendmentRequestApproval("approved"),
      visible:
        bookingDetails?.leaseAmendmentRequest &&
        bookingDetails?.leaseAmendmentRequest !== "approved" &&
        !bookingCancelled,
    },
    {
      label: "Reject Lease Amendments",
      type: "reject",
      action: () => leaseAmendmentRequestApproval("rejected"),
      visible:
        bookingDetails?.leaseAmendmentRequest &&
        bookingDetails?.leaseAmendmentRequest !== "approved" &&
        !bookingCancelled,
    },
    {
      label: "Send for Landlord Signature",
      type: "accept",
      action: () => openModalPopup(10),
      visible: isLandLoardSigned && !bookingCancelled,
    },
    {
      label: "Approve Extension",
      type: "accept",
      action: () => approveBookingExtention(),
      visible:
        bookingExtension &&
        !bookingCancelled &&
        bookingDetails?.bookingExtension?.status !== "approved" &&
        !loginUserRole?.includes("leaseExecutive") &&
        !isRenewal &&
        leaseStatus !== "lease_expired",
    },

    {
      label: "Confirm Final Settlement",
      type: "accept",
      action: () => confirmFinalSettlement(),
      visible:
        bookingDetails?.moveOutStatus &&
        bookingDetails?.moveOutStatus === "settlement_approved" &&
        moveOutScreenStatus &&
        !bookingCancelled,
    },
    {
      label: "Send Settlement",
      type: "accept",
      action: () => sendSettlementReport(),
      visible:
        bookingDetails?.moveOutStatus &&
        bookingDetails?.moveOutStatus === "settlement_confirmed" &&
        bookingDetails?.settlementApproval === "approved" &&
        moveOutScreenStatus &&
        !bookingCancelled,
    },
    {
      label:
        !bookingDetails?.renewalTerms?.renewalNotifiedToTenant ||
        bookingDetails?.renewalTerms?.renewalNotifiedToTenant <= 1 ||
        renewalStatus === "ready_to_send"
          ? "Send Renewal"
          : "Resend Notice",
      type: "accept",
      action: () => handleRenewal("send_renewal", true),
      visible:
        bookingDetails?.renewalStatus === "ready_to_send" &&
        isRenewal &&
        leaseStatus !== "lease_expired" &&
        !bookingCancelled,
    },
    {
      label: "Reject Extension",
      type: "reject",
      action: () => openModalPopup(9),
      visible:
        bookingExtension &&
        !bookingCancelled &&
        bookingDetails?.bookingExtension?.status !== "approved" &&
        !loginUserRole?.includes("leaseExecutive") &&
        leaseStatus !== "lease_expired",
    },
    {
      label: "Send to tenant",
      type: "accept",
      action: () => sendToTenant(),
      visible: !isRenewal && statusMap["booking_created"] && leaseStatus !== "lease_expired" && !bookingCancelled,
      disabled: bookingDetails?.paymentPlanApproval?.toLowerCase() === "sent",
    },
    {
      label: "Re-Send to tenant",
      type: "accept",
      action: () => sendToTenant(),
      visible:
        !isRenewal && statusMap["tenant_invitation_sent"] && leaseStatus !== "lease_expired" && !bookingCancelled,
    },
    {
      label: "Approve Tenant Information",
      type: "accept",
      action: () => ApproveTenantInfo(),
      visible:
        !bookingCancelled &&
        !isRenewal &&
        statusMap["documents_approved"] &&
        !statusMap["kyc_approved"] &&
        !statusMap["kyc_rejected"] &&
        bookingDetails?.paymentPlanApproval !== "sent" &&
        leaseStatus !== "lease_expired" &&
        leaseStatus !== "active_renewing" &&
        !bookingCancelled,
    },
    {
      label: "Reject Tenant Information",
      type: "reject",
      action: () => openModalPopup(0),
      visible:
        !bookingCancelled &&
        !isRenewal &&
        statusMap["documents_approved"] &&
        !statusMap["kyc_approved"] &&
        !statusMap["kyc_rejected"] &&
        bookingDetails?.paymentPlanApproval !== "sent" &&
        leaseStatus !== "lease_expired" &&
        leaseStatus !== "active_renewing" &&
        !bookingCancelled,
    },
    {
      label: `${statusMap["sent_for_booking_approval"] ? "Sent" : "Send"} for Approval`,
      type: "accept",
      action: () => sendForApproval(),
      visible:
        !isRenewal &&
        !bookingCancelled &&
        (statusMap["send_for_booking_approval"] || statusMap["sent_for_booking_approval"]) &&
        loginUserType(["leaseManager", "landlord"]) &&
        leaseStatus !== "lease_expired",
      disabled: statusMap["sent_for_booking_approval"] || bookingDetails?.paymentPlanApproval === "sent",
    },
    {
      label: "Edit Booking",
      type: "accept",
      action: () => editBooking("bookingApproval"),
      visible:
        !isRenewal &&
        !bookingCancelled &&
        loginUserType(["leaseManager", "landlord"]) &&
        statusMap["sent_for_booking_approval"] &&
        leaseStatus !== "lease_expired",
    },
    {
      label: "Approve",
      type: "accept",
      action: () => AcceptApproval(),
      visible:
        !isRenewal &&
        loginUserType(["managersManager", "landlord"]) &&
        managerApproval &&
        statusMap["sent_for_booking_approval"] &&
        leaseStatus !== "lease_expired" &&
        !bookingCancelled,
    },
    {
      label: "Reject",
      type: "reject",
      action: () => openModalPopup(1),
      visible:
        !isRenewal &&
        loginUserType(["managersManager", "landlord"]) &&
        managerApproval &&
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        statusMap["sent_for_booking_approval"],
    },

    // ********* The purpose of this work item is to allow a leasing team
    // to resend a renewal notice to the tenant once renewal terms
    //  are changed from the last time the renewal was sent **************.

    {
      type: "accept",
      label: "Resend Notice",
      action: () => renewalNoticeSend(),
      visible:
        (renewalStatus === "sent" &&
          isRenewal &&
          bookingDetails?.renewalTerms &&
          !bookingCancelled &&
          bookingDetails?.renewalTerms?.renewalNotifiedToTenant > 1) ||
        (bookingDetails?.renewalTerms && confirmMoveOut(renewalStatus)),
    },

    // ************* according to Ajay  if lease start date less than current date
    // and also renewalStatus === 'sent' than renewal is expired and
    //  show allow renewal button **********************************
    {
      type: "accept",
      label: "Allow Late Renewal",
      action: () => allowLateRenewal(),
      visible:
        renewalStatus === "sent" &&
        isRenewal &&
        !bookingCancelled &&
        bookingDetails?.parentLeaseAllowLateRenewal?.toLowerCase() !== "yes" &&
        leaseStatus !== "lease_expired" &&
        getDiffInDays(bookingDetails?.leaseTerms?.leaseStartDate) < 0 &&
        !bookingCancelled,
    },
    // *****  for story 8455 Upcoming Renewals > Add buttons for Confirm Renewal and Confirm Move-out ******

    {
      label: "Decline Renewal",
      type: "delete",
      action: () => openModalPopup(7), //this will come in renewal
      visible: declinRenwal(renewalStatus), //(bookingApproved ||  removed as per this bug: 7891
    },
    {
      label: "Confirm Move-out",
      type: "delete",
      action: () => openModalPopup(8), //this will come in renewal
      visible: confirmMoveOut(renewalStatus),
    },
    {
      label: "Confirm Renewal",
      type: "accept",
      action: () => showModalForConfirmRenwal(), //this will come in renewal
      visible: confirmRenwal(renewalStatus), //(bookingApproved ||  removed as per this bug: 7891
    },
    {
      label: "Confirm Payment Schedule",
      type: "accept",
      action: () => confirmPayments(), //this will come in renewal
      visible:
        (!bookingCancelled && depositPaid && !paymentsReceived && leaseStatus !== "lease_expired") ||
        // according to Ajay single upfront payment rent installment handeling
        ((leaseStatus === "awaiting_rent_payments" || leaseStatus === "rent_payments_received") &&
          (bookingDetails?.leaseType === "extension" || bookingDetails?.leaseType === "renewal")),
    },
    {
      label: `${statusMap["sent_for_lease_approval"] ? "Sent" : "Send"} Lease for Approval`,
      type: "accept",
      action: () => sendLeaseForApproval(),
      visible:
        !bookingCancelled &&
        leaseStatus !== "lease_expired" &&
        (statusMap["send_for_lease_approval"] || statusMap["sent_for_lease_approval"]) &&
        (!isRenewal ? loginUserType(["leaseManager", "landlord", "adminManager"]) : true) && //added renewal free check as per Vishwajeet
        !statusMap["active"],
      disabled: statusMap["sent_for_lease_approval"],
    },
    {
      label: `Edit ${!isRenewal ? "Booking" : "Renewal"}`,
      type: "accept",
      action: () => editBooking("leaseApproval"),
      visible:
        !bookingCancelled &&
        leaseStatus !== "lease_expired" &&
        (!isRenewal ? loginUserType(["leaseManager", "landlord", "adminManager"]) : true) &&
        statusMap["sent_for_lease_approval"],
    },
    {
      label: "Approve Lease",
      type: "accept",
      action: () => AcceptLeaseApproval(),
      //!isRenewal &&                    //this will come in renewal
      visible:
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        loginUserType(["managersManager", "landlord", "adminManagersManager"]) &&
        leaseManagerApproval &&
        statusMap["sent_for_lease_approval"],
    },
    {
      label: "Reject Lease",
      type: "reject",
      action: () => openModalPopup(2),
      visible:
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        loginUserType(["managersManager", "landlord", "adminManagersManager"]) &&
        leaseManagerApproval &&
        statusMap["sent_for_lease_approval"],
    },
    {
      label: `${contractSent ? "Re-send" : "Send"} Contract for eSignature`,
      type: "accept",
      action: () => sendForEsignature("TENANCY_CONTRACT"),

      visible:
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        contractCreated &&
        !tenantSigned &&
        !contractSigned && //KT test scenario
        leaseStatus !== "lease_expired" &&
        loginUserType(["leaseManager", "landlord", "adminManager", "adminManagersManager"]), //added adminManager checks ref: 8289 //added adminManagersManager: ref 8400
    },
    {
      label: "Activate",
      type: "accept",
      action: () => activateEjari(),
      //!isRenewal && //this will come in renewal
      visible:
        !bookingCancelled &&
        leaseStatus !== "lease_expired" &&
        contractSigned &&
        !statusMap["active"] &&
        leaseStatus !== "active_vacating" &&
        !state?.moveOut &&
        leaseStatus !== "active_renewing",
    },
    {
      label: "Activate Ejari Contract",
      type: "accept",
      action: () => createEjari(),
      visible:
        !bookingDetails?.moveOutStatus &&
        (!isRenewal || (isRenewal && bookingDetails?.leaseType === "extension" && leaseStatus === "active")) &&
        leaseStatus === "active" &&
        bookingDetails?.earlyTerminationRequestStatus !== "pending" &&
        // // for hendling case renewal to renewal
        // (renewalStatus =='active' && leaseStatus == "active" && !state?.renewalTorenewal) &&
        bookingDetails?.leaseStatusHistory?.length > 0, //renewal check added for bug: 8287
      disabled: !bookingDetails?.ejariIntegration,
    },
    {
      label: "Download Ejari Certificate",
      type: "accept",
    },
    {
      label: "Sent Plan for Approval",
      type: "accept",
      action: () => {},
      visible:
        !isRenewal &&
        !bookingCancelled &&
        loginUserType(["leaseManager"]) &&
        leaseStatus !== "lease_expired" &&
        bookingDetails?.paymentPlanApproval === "sent",
      disabled: true,
    },
    {
      label: "Approve",
      type: "accept",
      action: () => handleRenewal("payment_plan_approve", true),
      visible:
        !isRenewal &&
        loginUserType(["managersManager", "landlord"]) &&
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        bookingDetails?.paymentPlanApproval === "sent",
    },
    {
      label: "Reject",
      type: "reject",
      action: () => openModalPopup(5),
      visible:
        !isRenewal &&
        loginUserType(["managersManager", "landlord"]) &&
        leaseStatus !== "lease_expired" &&
        !bookingCancelled &&
        bookingDetails?.paymentPlanApproval === "sent",
    },
    {
      type: "accept",
      visible: renewalStatus === "to_review" && leaseStatus !== "lease_expired" && isRenewal && !bookingCancelled,
      action: () => handleRenewal(renewalApproval ? "create" : "approval"),
      label: `${renewalApproval ? "Send for Approval" : "Ready to Send"}`,
    },
    {
      type: "accept",
      label: "Approve",
      action: () => handleRenewal("approval", true),
      visible:
        renewalStatus === "sent_for_approval" &&
        loginUserType(["landlord", "managersManager", "adminManagersManager"]) &&
        leaseStatus !== "lease_expired" &&
        isRenewal &&
        !bookingCancelled,
    },
    {
      type: "reject",
      label: "Reject",
      action: () => openModalPopup(3),
      visible:
        renewalStatus === "sent_for_approval" &&
        loginUserType(["landlord", "managersManager", "adminManagersManager"]) &&
        leaseStatus !== "lease_expired" &&
        isRenewal &&
        !bookingCancelled,
    },
    {
      type: "accept",
      label: "Edit Renewal",
      action: () => handleRenewal("edit_renewal"),
      visible:
        renewalStatus === "sent_for_approval" && leaseStatus !== "lease_expired" && isRenewal && !bookingCancelled,
    },
    {
      type: "accept",
      label: "View Renewal",
      action: () => viewRenewalLease(bookingDetails?.renewalLeaseId, userScreenAccess),
      visible:
        bookingDetails?.renewalLeaseId &&
        leaseStatus !== "lease_expired" &&
        !bookingDetails?.moveOutStatus &&
        !bookingCancelled,
    },
  ];

  return (
    <>
      <Space>
        {actionButtons
          .filter((e) => e.visible)
          .map((item, index) => {
            let button = { classes: "", buttonType: "" };
            if (item.type === "delete") button.classes = "ef-discard-btn";
            else if (item.type === "reject") button.classes = "ef-reject-btn";
            else if (item.type === "accept") button.classes = "ef-approve-btn";
            return (
              <Button
                key={index}
                className={button?.classes}
                disabled={item?.disabled}
                type="primary"
                onClick={item.action}
              >
                {item.label}
              </Button>
            );
          })}
      </Space>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};

export default ActionButtons;
